import React from "react";

const IconSave = () => {
	return <em className="fa-light fa-floppy-disks"></em>;
};

export default IconSave;
